module.exports = __webpack_public_path__ + "static/media/ic-mypoints.a3c1ee14.svg";